import { MouseEvent, useEffect, useState } from 'react';
import copy from 'copy-text-to-clipboard';

const CLIPBOARD_RESET_TIMER = 3000;

interface UseCopyProps<E = HTMLButtonElement> {
  inPortal?: boolean;
  onCopy?: (e: MouseEvent<E>, text: string) => void;
}

export const useCopy = ({ onCopy, inPortal }: UseCopyProps = {}) => {
  const [didCopy, setDidCopy] = useState(false);

  const onClickCopy = <E = HTMLButtonElement,>(e: MouseEvent<E>, text: string) => {
    copy(text, {
      target: inPortal
        ? (document.querySelector("[role='alertdialog']") as HTMLElement)
        : document.body,
    });
    setDidCopy(true);
    onCopy && onCopy(e as MouseEvent<HTMLButtonElement>, text);
  };

  useEffect(() => {
    if (didCopy) {
      setTimeout(() => setDidCopy(false), CLIPBOARD_RESET_TIMER);
    }
  }, [didCopy]);

  return {
    didCopy,
    setDidCopy,
    onClickCopy,
  };
};
